<template>
    <div>
        <div class="elo" v-on:click="helpElo=true">
            <div :class="classLevel">
                <div class="titleElo">
                    {{level}} 
                </div>
                <div v-if="number">
                    {{Math.ceil(elo)}}
                </div>
            </div>
        </div>
        <s-info v-if="!number" id="elo_explain" :open="helpElo" @close="helpElo=false" :close="true">Il s'agit de votre niveau au sens Petanque-app. </s-info>
        <s-info :big="true" v-if="number" id="elo_explainBig" :open="helpElo" @close="helpElo=false" :close="true">Il s'agit de votre niveau au sens Petanque-app. </s-info>
    </div>    
</template>
<style scoped>
    .elo {
            border: thin black thin;
            padding : 0px;
            margin-left: 10px;
            font-size: 14px;
            text-align: center;
            font-weight: bolder;
            color: white;
            border-radius: 20px;
            width: 100px;
            margin-bottom: 10px;
        }
    .elo:hover {cursor: help;}
    .titleElo {
        padding: 10px;
        font-size: 15px;
        color: white;
    }
    .CLASSE_A {
            background-color: rgb(51, 214, 1);
            border-radius: 20px;
        }
        .CLASSE_B {
            background-color: rgb(8, 148, 31);
            border-radius: 20px;
        }
        .CLASSE_C {
            background-color: rgb(141, 107, 6);
            border-radius: 20px;
        }
        .CLASSE_D {
            background-color: rgb(88, 71, 22);
            border-radius: 20px;
        }
        .EXPERT {
            font-weight: bolder;
            background-color: rgb(197, 31, 9);
            color: white;
            border-radius: 20px;
        }
        .ELITE {
            font-weight: bolder;
            background-color: rgb(128, 21, 7);
            color: white;
            border-radius: 20px;
        }
        .MAITRE {
            font-weight: bolder;
            background-color: rgb(2, 2, 2);
            color: white;
            border-radius: 20px;
        }
</style>
<script>
export default {
    props: ["elo", "number"],
    data() {
        return {
            helpElo: false
        }
    },
    computed: {
        level: {
            get() {
                var elo = this.elo;
                
                if (elo<1200)
                    return "CLASSE D"
                else if (elo<1400)
                    return "CLASSE C"
                else if (elo<1500) 
                    return "CLASSE B"
                else if (elo<1800)
                    return "CLASSE A"
                else if (elo<2000)
                    return "EXPERT"
                else if (elo<2300)
                    return "ELITE"
                else 
                    return "MAITRE"
            }   
        },
        classLevel: {
            get() {
                var elo = this.elo;
               
                if (elo<1200)
                    return "CLASSE_D"
                else if (elo<1400)
                    return "CLASSE_C"
                else if (elo<1500) 
                    return "CLASSE_B"
                else if (elo<1800)
                    return "CLASSE_A"
                else if (elo<2000)
                    return "EXPERT"
                else if (elo<2300)
                    return "ELITE"
                else 
                    return "MAITRE"
            }   
        },
    }
}
</script>